import { useState, useEffect, MouseEvent } from "react";
import { Modal, Form, Table, Button } from "react-bootstrap";
import { useAppSelector } from "../../../../redux/hooks";
import { lddGlobalSessionInfo } from "../../../navigationTypes";
import { getCustomFieldSet, saveCustomFieldSet, updateCustomFieldSet } from "./customFieldSetFuncs";
import { ClientConnectCustomFieldSet, defaultFieldSet } from "./types";

export type NewCustomFieldSetModalProps = {
    show: boolean;
    onHide: {
        (): void;
        (event: MouseEvent<HTMLButtonElement, MouseEvent>): void;
    };
    editFieldSet: ClientConnectCustomFieldSet,
    fromSettings: boolean
}


export const NewCustomFieldSetModal = (props: NewCustomFieldSetModalProps) => {
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const [fieldSet, setFieldSet] = useState<ClientConnectCustomFieldSet>(defaultFieldSet);
    const [clear, setClear] = useState<boolean>(false);

    useEffect(() => {
        if (props.editFieldSet) {
            setFieldSet(props.editFieldSet)
        } else {
            for (let i = 0; i < fieldSet.fields.length; i++) {
                handleFieldCleared(i)
            }
            setFieldSet(defaultFieldSet)
        }
    }, [props.editFieldSet, props.show])


    const handleFieldChange = (index, event) => {
        const newFields = fieldSet.fields;
        newFields[index].name = (fieldSet[index] ? fieldSet[index] : '') + event.target.value;
        setFieldSet({
            fieldSetName: fieldSet.fieldSetName,
            fields: newFields,
        })
    }

    const addNewField = () => {
        const emptyFieldSet = fieldSet.fields;
        emptyFieldSet.push({ name: '', type: 'text', perClient: false, value: '', fromSet: true, id: '-1' })
        setFieldSet({
            fieldSetName: fieldSet.fieldSetName,
            fields: emptyFieldSet,
        })
    }

    const handleFieldSetNameChange = (event) => {
        const newFieldSetName = event.target.value;
        setFieldSet({
            fieldSetName: newFieldSetName,
            fields: fieldSet.fields,
        })
    }

    const handleSwitchToggle = (index, event) => {

        const newFields = fieldSet.fields;
        newFields[index].perClient = event.target.checked;

        setFieldSet({
            fieldSetName: fieldSet.fieldSetName,
            fields: newFields,
        })
    }

    const handleFieldCleared = (index) => {

        let newFields = fieldSet.fields;
        fieldSet.fields.splice(index, 1)

        setFieldSet({
            fieldSetName: fieldSet.fieldSetName,
            fields: newFields,
        })
    }

    const handleNewFieldSetSaveClicked = async () => {
        const fSet = { ...fieldSet };
        fSet.fields = fSet.fields.filter(f => f && f.name);
        let result: boolean;

        if (fSet.fieldSetName === '') {
            alert('You must include a field set name.')
        } else if (fSet.fields.length === 0) {
            alert('You must include at least one field.')
        } else if (props.editFieldSet) {
            result = await updateCustomFieldSet(sessionInfo.sid, fSet, props.editFieldSet);
        } else {
            result = await saveCustomFieldSet(sessionInfo.sid, fSet);
        }

        if (result) {
            alert('Successfully Saved');
            for (let i = 0; i < fSet.fields.length; i++) {
                handleFieldCleared(i);
            }
            setClear(true)
            props.onHide()
        }
    }

    const onHide = () => {
        for (let i = 0; i < fieldSet.fields.length; i++) {
            handleFieldCleared(i)
        }
        props.onHide();
    }

    useEffect(() => {
        if (clear) {
            setFieldSet(defaultFieldSet)
            setClear(false)
        }
    }, [clear])


    return (
        <Modal show={props.show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{props.fromSettings && <>New</>} Intake Template {!props.fromSettings && <>(View Only)</>}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Label>Intake Template Name</Form.Label>
                <Form.Control
                    className="standard-form"
                    name='fieldSetName'
                    value={fieldSet.fieldSetName}
                    onChange={(event) => handleFieldSetNameChange(event)}
                    disabled={!props.fromSettings}
                />
                <br />
                <Table className="table-input" bordered>
                    <thead>
                        <tr>
                            <th>Intake Field Name</th>
                            {/* <th>Per Client</th> */}
                            {props.fromSettings && <th></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {fieldSet.fields.map((field, index) => {
                            return (
                                <tr key={'new-field-' + index}>
                                    <td>
                                        <Form.Control
                                            className="standard-form"
                                            name='fieldSetName'
                                            value={field.name}
                                            onChange={(event) => handleFieldChange(index, event)}
                                            placeholder="enter a field name.."
                                            disabled={!props.fromSettings}
                                        />
                                    </td>
                                    {/* <td>
                                        <Form.Check // prettier-ignore
                                            type="switch"
                                            id="perClientSwitch"
                                            onChange={(event) => handleSwitchToggle(index, event)}
                                            checked={field.perClient}
                                            disabled={!props.fromSettings}
                                        />
                                    </td> */}
                                    {props.fromSettings &&
                                        <td style={{ width: '50px' }}>
                                            <Button
                                                variant="link"
                                                onClick={() => handleFieldCleared(index)}
                                            >
                                                <i className="fa-regular fa-trash-can"></i>
                                            </Button>

                                        </td>
                                    }
                                </tr>
                            )
                        })}
                    </tbody>

                    {props.fromSettings &&
                        <tfoot>
                            <tr>
                                <td colSpan={3}>
                                    <Button
                                        variant='link-text'
                                        onClick={() => addNewField()}
                                    >
                                        + Field
                                    </Button>
                                </td>
                            </tr>
                        </tfoot>
                    }
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    onHide();
                }}>
                    Cancel
                </Button>
                {
                    props.fromSettings &&
                    <Button variant="primary" onClick={() => {
                        setFieldSet(defaultFieldSet)
                        handleNewFieldSetSaveClicked()
                    }}>
                        Save
                    </Button>
                }
            </Modal.Footer>
        </Modal>
    )
}
